<template>
  <div class="breadcrumbs">
    <NuxtLink to="/" v-if="rootSlug" :class="{ 'is-parent': true }" :aria-label="$t('shared.domain')">
      {{ $t('shared.nav.start') }}
    </NuxtLink>
    <span v-html="`/`" v-if="true" />
    <NuxtLink :to="`/${rootSlug}`" v-if="rootSlug" :class="{ 'is-parent': city?.slug }">
      {{ useUcFirst(rootSlug) }}
    </NuxtLink>
    <span v-html="`/`" v-if="city?.slug" />
    <NuxtLink :to="`/${rootSlug}/${city?.slug}`" v-if="city">
      {{ city?.name }}
    </NuxtLink>
  </div>
</template>

<script setup>
const route = useRoute()
const app = useAppStore()

// Root Slug from page path
const rootSlug = computed(() => route.path?.split('/')[1])

// Get City and City ID's from app store
const city = computed(() => app.cities?.find(city => city.slug === route.path?.split('/')[2]))
</script>
